/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _partition from 'lodash/partition'
import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { withLocalization } from 'hocs/localization'
import { onGetShippingHistory } from 'redux-app/actionCreators/users'
import { getShippingHistory } from 'redux-app/selectors/user'
import { isDateAfter } from 'shared/utils/date'
import ShippingHistory from './ShippingHistory'

const getNormalizedShippingHistory = createSelector(
  getShippingHistory,
  shippingHistory => {
    const splitted = _partition(shippingHistory, item => !item.deliveredAt)
    const withoutDate = splitted[0].sort((a, b) =>
      a.items[0].toLowerCase() > b.items[0].toLowerCase() ? 1 : -1)
    const withDate = splitted[1].sort((a, b) =>
      isDateAfter(a.deliveredAt, b.deliveredAt) ? -1 : 1)

    return withoutDate.concat(withDate)
  })

export default compose(
  connect(
    state => {
      return {
        subscriptionHistory: getNormalizedShippingHistory(state),
      }
    },
    {
      onGetShippingHistory,
    },
  ),
  withLocalization('profile.shippingHistory'),
  lifecycle<any, any>({
    componentWillMount () {
      this.props.onGetShippingHistory()
        .then(res => {
          this.setState({
            loadProgress: 100,
          })
        }).catch(() => {
          this.setState({
            loadProgress: 100,
          })
        })
    },
  }),
)(ShippingHistory)
